import View from './View';

export { default as View } from './View';
export { default as getFallbackImageStyles } from './styles';

export default View;
